import { api } from './api'
import type { OIDCClient, OIDCClientsResponse, CreateClientRequest, UpdateClientRequest } from '@/api/types/client'

export const clientsApi = {
  getClients: async (next_token?: string): Promise<OIDCClientsResponse> => {
    console.log('🔍 Fetching OIDC clients', { next_token })
    const params = next_token ? { next_token: next_token } : {}
    const response = await api.get<OIDCClientsResponse>('/oidc/clients', { params })
    console.log('✅ Fetched OIDC clients:', response.data)
    return response.data
  },

  getClient: async (client_id: string): Promise<OIDCClient> => {
    console.log('🔍 Fetching OIDC client:', client_id)
    const response = await api.get<OIDCClient>(`/oidc/clients/${client_id}`)
    console.log('✅ Fetched OIDC client:', response.data)
    return response.data
  },

  createClient: async (request: CreateClientRequest): Promise<OIDCClient> => {
    console.log('📝 Creating OIDC client:', request)
    const response = await api.post<OIDCClient>('/oidc/clients', request)
    console.log('✅ Created OIDC client:', response.data)
    return response.data
  },

  updateClient: async (request: UpdateClientRequest): Promise<OIDCClient> => {
    console.log('📝 Updating OIDC client:', request)
    const response = await api.put<OIDCClient>(`/oidc/clients/${request.client_id}`, request)
    console.log('✅ Updated OIDC client:', response.data)
    return response.data
  },

  deleteClient: async (client_id: string): Promise<void> => {
    console.log('🗑️ Deleting OIDC client:', client_id)
    await api.delete(`/oidc/clients/${client_id}`)
    console.log('✅ Deleted OIDC client')
  }
}